export { BrandingForm } from './BrandingForm';

// Ory branding
export const polisBranding = {
  logoUrl: '/logo.png',
  faviconUrl: '/favicon.ico',
  companyName: 'Tiiny Host',
  primaryColor: '#4f39f6',
};
